import { put, delay, call, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';


function* myProofPersonAdd(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('imageBase64', payload.imageBase64);
    params.append('imageSubBase64', payload.imageSubBase64);
    return axios.post(config.apiUri + "member/myProofPersonAddApi.php", params, {
      timeout: 60000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield delay(500);
      yield put({
        type: "MY_PROFILE_GET",
        payload: {
    			item: ['proof','request'],
    		},
      });
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment:'証明書を申請しました。12時間以内に申請結果をメールでお知らせします'} });
      action.callback();
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* myProofAddNext(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'add');
    params.append('proofType', payload.proofType);
    payload.imageBase64Arr.forEach((value) => {
      params.append('imageBase64Arr[]', value);
    });
    return axios.post(config.apiUri + "member/myProofEditNextApi.php", params, {
      timeout: 60000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield delay(500);
      yield put({
        type: "MY_PROFILE_GET",
        payload: {
    			item: ['proof','request'],
    		},
      });
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment:'証明書を申請しました。12時間以内に申請結果をメールでお知らせします'} });
      action.callback();
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* myProofAdd(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'add');
    params.append('proofType', payload.proofType);
    params.append('imageBase64', payload.imageBase64);
    params.append('properties', 'NA');
    return axios.post(config.apiUri + "member/myProofEditApi.php", params, {
      timeout: 60000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield delay(500);
      yield put({
        type: "MY_PROFILE_GET",
        payload: {
    			item: ['proof','request'],
    		},
      });
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment:'証明書を申請しました。12時間以内に申請結果をメールでお知らせします'} });
      action.callback();
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* myProofDel(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'del');
    params.append('proofType', payload.proofType);
    return axios.post(config.apiUri + "member/myProofEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield delay(500);
      yield put({
        type: "MY_PROFILE_GET",
        payload: {
    			item: ['proof'],
    		},
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* myProofWantEdit(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('personWant', payload.personWant);
    params.append('photoWant', payload.photoWant);
    params.append('incomeWant', payload.incomeWant);
    params.append('singleWant', payload.singleWant);
    params.append('creditWant', payload.creditWant);
    return axios.post(config.apiUri + "member/myProofWantEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield delay(500);
      yield put({
        type: "MY_PROFILE_GET",
        payload: {
    			item: ['proof'],
    		},
      });
      action.callback();
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* myProofRekognitionCheck(action) {
  const {res} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('imageBase64', payload.imageBase64);
    return axios.post(config.apiUri + "member/myProofRekognitionCheckApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
  }, action.payload);
  if (res) {
    action.callback(res.data);
  }
}

const saga = [
  takeLatest('MY_PROOF_PERSON_ADD', myProofPersonAdd),
  takeLatest('MY_PROOF_ADD_NEXT', myProofAddNext),
  takeLatest('MY_PROOF_ADD', myProofAdd),
  takeLatest('MY_PROOF_DEL', myProofDel),
  takeLatest('MY_PROOF_WANT_EDIT', myProofWantEdit),
  takeLatest('MY_PROOF_REKOGNITION_CHECK', myProofRekognitionCheck),
];

export default saga;
